import styled from 'styled-components';

type TextProps = {
  w?: string;
  weight?: string;
  color?: string;
  size?: string;
  mt?: string;
  mb?: string;
  ml?: string;
};

const Text = styled.div`
  width: ${(props: TextProps) => (props.w ? props.w : 'auto')};
  font-weight: ${(props: TextProps) =>
    props.weight ? props.weight : 'normal'};
  font-size: ${(props: TextProps) => (props.size ? props.size : '16px')};
  color: ${(props: TextProps) => (props.color ? props.color : 'black')};

  margin-top: ${(props: TextProps) => (props.mt ? props.mt : '0px')};
  margin-bottom: ${(props: TextProps) => (props.mb ? props.mb : '0px')};
  margin-left: ${(props: TextProps) => (props.ml ? props.ml : '0px')};

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

type HeaderTextProps = TextProps & {
  isSelected: boolean;
};

const HeaderText = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;

  color: ${(props: HeaderTextProps) =>
    props.isSelected ? props.color : 'white'};
  border-radius: 12px;
  width: 25%;
  height: 28px;
  font-weight: 800;
  font-size: 16px;
  padding: 0px 5px;
  z-index: 999;

  transition-property: color;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);

  cursor: pointer;
`;

const DText = styled(Text)`
  color: ${(props: TextProps) => (props.color ? props.color : 'white')};
  text-align: left;
  white-space: pre-line;
`;

export { Text, HeaderText, DText };
